export const GST1Data = [
  {
    invoiceDate: "2024-08-05T00:00:00.000+00:00",
    invoiceNo: "INV002",
    customerName: "XYZ Enterprises",
    customerGSTIN: "29BBBBB1111B1Z6",
    placeOfSupply: "Maharashtra",
    typeOfSupply: "Intrastate",
    taxableValue: 50000,
    cgst: 4500,
    sgst: 4500,
    igst: 0,
    totalInvoiceValue: 59000,
  },
  {
    invoiceDate: "2024-08-10T00:00:00.000+00:00",
    invoiceNo: "INV003",
    customerName: "PQR Industries",
    customerGSTIN: "27CCCCC2222C1Z7",
    placeOfSupply: "Maharashtra",
    typeOfSupply: "Intrastate",
    taxableValue: 200000,
    cgst: 18000,
    sgst: 18000,
    igst: 0,
    totalInvoiceValue: 236000,
  },
  {
    invoiceDate: "2024-08-15T00:00:00.000+00:00",
    invoiceNo: "INV004",
    customerName: "DEF Co.",
    customerGSTIN: "07DDDDD3333D1Z8",
    placeOfSupply: "Delhi",
    typeOfSupply: "Interstate",
    taxableValue: 150000,
    cgst: 0,
    sgst: 0,
    igst: 27000,
    totalInvoiceValue: 177000,
  },
  {
    invoiceDate: "2024-08-20T00:00:00.000+00:00",
    invoiceNo: "INV005",
    customerName: "MNO Ltd.",
    customerGSTIN: "24EEEEE4444E1Z9",
    placeOfSupply: "Gujarat",
    typeOfSupply: "Interstate",
    taxableValue: 75000,
    cgst: 0,
    sgst: 0,
    igst: 13500,
    totalInvoiceValue: 88500,
  },
  {
    invoiceDate: "2024-08-25T00:00:00.000+00:00",
    invoiceNo: "INV006",
    customerName: "Gurugram's Company",
    customerGSTIN: "06GGGGG5555G1Z0",
    placeOfSupply: "Haryana",
    typeOfSupply: "Intrastate",
    taxableValue: 125000,
    cgst: 11250,
    sgst: 11250,
    igst: 0,
    totalInvoiceValue: 147500,
  },
  {
    invoiceDate: "2024-09-01T00:00:00.000+00:00",
    invoiceNo: "INV007",
    customerName: "STU Corp.",
    customerGSTIN: "08HHHHH6666H1Z1",
    placeOfSupply: "Rajasthan",
    typeOfSupply: "Interstate",
    taxableValue: 50000,
    cgst: 0,
    sgst: 0,
    igst: 9000,
    totalInvoiceValue: 59000,
  },
  {
    invoiceDate: "2024-09-05T00:00:00.000+00:00",
    invoiceNo: "INV008",
    customerName: "JKL Pvt. Ltd.",
    customerGSTIN: "21IIIIIIII1I1Z2",
    placeOfSupply: "Odisha",
    typeOfSupply: "Intrastate",
    taxableValue: 175000,
    cgst: 15750,
    sgst: 15750,
    igst: 0,
    totalInvoiceValue: 206500,
  },
  {
    invoiceDate: "2024-09-10T00:00:00.000+00:00",
    invoiceNo: "INV009",
    customerName: "LMN Industries",
    customerGSTIN: "19JJJJJ7777J1Z3",
    placeOfSupply: "West Bengal",
    typeOfSupply: "Interstate",
    taxableValue: 60000,
    cgst: 0,
    sgst: 0,
    igst: 10800,
    totalInvoiceValue: 70800,
  },
  {
    invoiceDate: "2024-09-15T00:00:00.000+00:00",
    invoiceNo: "INV010",
    customerName: "QRS Enterprises",
    customerGSTIN: "32KKKKK8888K1Z4",
    placeOfSupply: "Kerala",
    typeOfSupply: "Intrastate",
    taxableValue: 90000,
    cgst: 8100,
    sgst: 8100,
    igst: 0,
    totalInvoiceValue: 106200,
  },
  {
    invoiceDate: "2024-09-20T00:00:00.000+00:00",
    invoiceNo: "INV011",
    customerName: "TUV Ltd.",
    customerGSTIN: "05LLLLL9999L1Z5",
    placeOfSupply: "Uttarakhand",
    typeOfSupply: "Interstate",
    taxableValue: 130000,
    cgst: 0,
    sgst: 0,
    igst: 23400,
    totalInvoiceValue: 153400,
  },
];

export const GST2Report = [
  {
    invoiceDate: "02-08-2024",
    invoiceNo: "PUR001",
    supplierName: "ABC Pvt. Ltd.",
    supplierGSTIN: "22AAAAA0000A1Z5",
    placeOfSupply: "Karnataka",
    typeOfSupply: "Interstate",
    taxableValue: 150000,
    cgst: 0,
    sgst: 0,
    igst: 27000,
    totalInvoiceValue: 177000,
    itcClaimed: 27000,
  },
  {
    invoiceDate: "07-08-2024",
    invoiceNo: "PUR002",
    supplierName: "XYZ Enterprises",
    supplierGSTIN: "29BBBBB1111B1Z6",
    placeOfSupply: "Maharashtra",
    typeOfSupply: "Intrastate",
    taxableValue: 75000,
    cgst: 6750,
    sgst: 6750,
    igst: 0,
    totalInvoiceValue: 88500,
    itcClaimed: 13500,
  },
  {
    invoiceDate: "12-08-2024",
    invoiceNo: "PUR003",
    supplierName: "PQR Industries",
    supplierGSTIN: "27CCCCC2222C1Z7",
    placeOfSupply: "Maharashtra",
    typeOfSupply: "Intrastate",
    taxableValue: 200000,
    cgst: 18000,
    sgst: 18000,
    igst: 0,
    totalInvoiceValue: 236000,
    itcClaimed: 36000,
  },
  {
    invoiceDate: "17-08-2024",
    invoiceNo: "PUR004",
    supplierName: "DEF Co.",
    supplierGSTIN: "07DDDDD3333D1Z8",
    placeOfSupply: "Delhi",
    typeOfSupply: "Interstate",
    taxableValue: 100000,
    cgst: 0,
    sgst: 0,
    igst: 18000,
    totalInvoiceValue: 118000,
    itcClaimed: 18000,
  },
  {
    invoiceDate: "23-08-2024",
    invoiceNo: "PUR005",
    supplierName: "MNO Ltd.",
    supplierGSTIN: "24EEEEE4444E1Z9",
    placeOfSupply: "Gujarat",
    typeOfSupply: "Interstate",
    taxableValue: 125000,
    cgst: 0,
    sgst: 0,
    igst: 22500,
    totalInvoiceValue: 147500,
    itcClaimed: 22500,
  },
  {
    invoiceDate: "28-08-2024",
    invoiceNo: "PUR006",
    supplierName: "JKL Pvt. Ltd.",
    supplierGSTIN: "08FFFFF5555F1Z0",
    placeOfSupply: "Rajasthan",
    typeOfSupply: "Interstate",
    taxableValue: 175000,
    cgst: 0,
    sgst: 0,
    igst: 31500,
    totalInvoiceValue: 206500,
    itcClaimed: 31500,
  },
  {
    invoiceDate: "02-09-2024",
    invoiceNo: "PUR007",
    supplierName: "GHI Corp.",
    supplierGSTIN: "09GGGGG6666G1Z1",
    placeOfSupply: "Uttar Pradesh",
    typeOfSupply: "Intrastate",
    taxableValue: 50000,
    cgst: 4500,
    sgst: 4500,
    igst: 0,
    totalInvoiceValue: 59000,
    itcClaimed: 9000,
  },
  {
    invoiceDate: "12-09-2024",
    invoiceNo: "PUR009",
    supplierName: "QRS Ltd.",
    supplierGSTIN: "11IIIII8888I1Z3",
    placeOfSupply: "Assam",
    typeOfSupply: "Intrastate",
    taxableValue: 125000,
    cgst: 11250,
    sgst: 11250,
    igst: 0,
    totalInvoiceValue: 147500,
    itcClaimed: 22500,
  },
  {
    invoiceDate: "18-09-2024",
    invoiceNo: "PUR010",
    supplierName: "TUV Enterprises",
    supplierGSTIN: "12JJJJJ9999J1Z4",
    placeOfSupply: "Jharkhand",
    typeOfSupply: "Interstate",
    taxableValue: 100000,
    cgst: 0,
    sgst: 0,
    igst: 18000,
    totalInvoiceValue: 118000,
    itcClaimed: 18000,
  },
  {
    invoiceDate: "22-09-2024",
    invoiceNo: "PUR011",
    supplierName: "UVW Pvt. Ltd.",
    supplierGSTIN: "13KKKKK0000K1Z5",
    placeOfSupply: "West Bengal",
    typeOfSupply: "Intrastate",
    taxableValue: 200000,
    cgst: 18000,
    sgst: 18000,
    igst: 0,
    totalInvoiceValue: 236000,
    itcClaimed: 36000,
  },
];

export const GST3BReport = [
  {
    taxable_value_inr: 500000,
    cgst_inr: 45000,
    sgst_inr: 45000,
    igst_inr: 0,
    cess_inr: 0,
    description: "Outward taxable supplies",
    childList: [
      {
        description:
          "Outward taxable supplies (other than zero-rated, nil-rated, and exempt)",
        taxable_value_inr: 500000,
        cgst_inr: 45000,
        sgst_inr: 45000,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Outward taxable supplies (zero-rated)",
        taxable_value_inr: 100000,
        cgst_inr: 0,
        sgst_inr: 0,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Other outward supplies (nil-rated, exempt)",
        taxable_value_inr: 50000,
        cgst_inr: 0,
        sgst_inr: 0,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Inward supplies (liable to reverse charge)",
        taxable_value_inr: 20000,
        cgst_inr: 1800,
        sgst_inr: 1800,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Non-GST outward supplies",
        taxable_value_inr: 30000,
        cgst_inr: 0,
        sgst_inr: 0,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Outward taxable supplies (exempt)",
        taxable_value_inr: 70000,
        cgst_inr: 0,
        sgst_inr: 0,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Outward taxable supplies (nil-rated)",
        taxable_value_inr: 25000,
        cgst_inr: 0,
        sgst_inr: 0,
        igst_inr: 0,
        cess_inr: 0,
      },
      {
        description: "Inward supplies (not liable to reverse charge)",
        taxable_value_inr: 15000,
        cgst_inr: 1350,
        sgst_inr: 1350,
        igst_inr: 0,
        cess_inr: 0,
      },
    ],
  },
];

export const dataReconciliation = {
  matchedList: [
    {
      id: 1,
      supplierGstin: "34AACCC1596Q002",
      customerGstin: "06AACCW0191M1Z5",
      invoiceNumber: "ORD031782",
      invoiceDate: "2025-03-06",
      invoiceValue: 2360.0,
      taxableValue: null,
      igst: 360.0,
      cgst: 0.0,
      sgst: 0.0,
      cess: null,
      matchStatus: "MATCHED",
      remarks: "Fully Matched with GSTR1",
      isSales: true,
    },
    {
      id: 2,
      supplierGstin: "34AACCC1596Q002",
      customerGstin: "06AACCW0191M1Z5",
      invoiceNumber: "ORD031782",
      invoiceDate: "2025-03-06",
      invoiceValue: 2360.0,
      taxableValue: null,
      igst: 360.0,
      cgst: 0.0,
      sgst: 0.0,
      cess: null,
      matchStatus: "MATCHED",
      remarks: "Fully Matched with GSTR1",
      isSales: true,
    },
  ],
  missingInPurchaseCount: 0,
  missingInPurchaseList: [],
  partiallyMatchedList: [],
  matchedCount: 2,
  missingInGSTR1List: [
    {
      id: 3,
      supplierGstin: "34AACCC1596Q002",
      customerGstin: "06AACCW0191M1Z5",
      invoiceNumber: "ORD031775",
      invoiceDate: "2025-03-06",
      invoiceValue: 1180.0,
      taxableValue: null,
      igst: 180.0,
      cgst: 0.0,
      sgst: 0.0,
      cess: null,
      matchStatus: "MISSING_IN_GST_PORTAL",
      remarks: "Invoice not found in GSTR1",
      isSales: true,
    },
    {
      id: 4,
      supplierGstin: "34AACCC1596Q002",
      customerGstin: "06AACCW0191M1Z5",
      invoiceNumber: "ORD031775",
      invoiceDate: "2025-03-06",
      invoiceValue: 1180.0,
      taxableValue: null,
      igst: 180.0,
      cgst: 0.0,
      sgst: 0.0,
      cess: null,
      matchStatus: "MISSING_IN_GST_PORTAL",
      remarks: "Invoice not found in GSTR1",
      isSales: true,
    },
    {
      id: 5,
      supplierGstin: "34AACCC1596Q002",
      customerGstin: "06AACCW0191M1Z5",
      invoiceNumber: "ORD031775",
      invoiceDate: "2025-03-06",
      invoiceValue: 1180.0,
      taxableValue: null,
      igst: 180.0,
      cgst: 0.0,
      sgst: 0.0,
      cess: null,
      matchStatus: "MISSING_IN_GST_PORTAL",
      remarks: "Invoice not found in GSTR1",
      isSales: true,
    },
    {
      id: 6,
      supplierGstin: "34AACCC1596Q002",
      customerGstin: "06AACCW0191M1Z5",
      invoiceNumber: "ORD031775",
      invoiceDate: "2025-03-06",
      invoiceValue: 1180.0,
      taxableValue: null,
      igst: 180.0,
      cgst: 0.0,
      sgst: 0.0,
      cess: null,
      matchStatus: "MISSING_IN_GST_PORTAL",
      remarks: "Invoice not found in GSTR1",
      isSales: true,
    },
  ],
  missingInGSTR1Count: 4,
  partiallyMatchedCount: 0,
};

export const headerConfigReconciliation = [
  { id: 1, name: "S.NO", alias: "SNO", isShow: "true", textAlign: "center" },
  {
    id: 2,
    name: "Invoice No.",
    alias: "invoiceNumber",
    isShow: "true",
    textAlign: "center",
  },
  {
    id: 3,
    name: "Invoice Date",
    alias: "invoiceDate",
    isShow: "true",
    textAlign: "center",
  },
  {
    id: 4,
    name: "Supplier GST",
    alias: "supplierGstin",
    isShow: "true",
    textAlign: "center",
  },
  {
    id: 5,
    name: "Customer GST",
    alias: "customerGstin",
    isShow: "true",
    textAlign: "center",
  },
  {
    id: 6,
    name: "Taxable Amount",
    alias: "taxableValue",
    isShow: "true",
    textAlign: "end",
  },
  {
    id: 7,
    name: "IGST",
    alias: "igst",
    isShow: "true",
    textAlign: "end",
    showGST: "integratedTaxAmount",
  },
  {
    id: 8,
    name: "CGST",
    alias: "cgst",
    isShow: "true",
    textAlign: "end",
    showGST: "centralTaxAmount",
  },
  {
    id: 9,
    name: "SGST",
    alias: "sgst",
    isShow: "true",
    textAlign: "end",
    showGST: "stateTaxAmount",
  },
  { id: 10, name: "CESS", alias: "cess", isShow: "true", textAlign: "end" },
  {
    id: 11,
    name: "Invoice Amount",
    alias: "invoiceValue",
    isShow: "true",
    textAlign: "end",
  },
  {
    id: 12,
    name: "Remark",
    alias: "remarks",
    isShow: "true",
    textAlign: "center",
  },
  {
    id: 13,
    name: "Status",
    alias: "tabMessage",
    isShow: "true",
    textAlign: "center",
  },
];

const currentYear = new Date().getFullYear(); // Get the current year
const startYear = 1950; // Define the earliest year

export const financialYearList = Array.from(
  { length: currentYear - startYear + 1 },
  (_, index) => ({
    id: index + 1,
    name: currentYear - index,
  })
);

export const financialYearMonthList = Array.from(
  { length: 12 },
  (_, index) => ({
    id: String(index + 1).padStart(2, "0"), // Ensures two-digit format (01, 02, ..., 12)
    name: new Date(2000, index).toLocaleString("en-US", { month: "long" }), // Get full month name
  })
);

export const darkenColor = (color, percent) => {
  let r = parseInt(color.substring(1, 3), 16);
  let g = parseInt(color.substring(3, 5), 16);
  let b = parseInt(color.substring(5, 7), 16);

  // Darken each color channel
  r = Math.max(0, Math.floor(r * (1 - percent)));
  g = Math.max(0, Math.floor(g * (1 - percent)));
  b = Math.max(0, Math.floor(b * (1 - percent)));

  // Convert back to Hex
  return `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};
